// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text-in-area[data-v-bf11c668] {\n  position: absolute;\n  transform: translate(-50%, -50%);\n  top: 50%;\n  left: 50%;\n  display: inline-block;\n  color: #ffffff;\n  background: #00457f;\n  z-index: 1;\n  padding: 15px 30px;\n}", ""]);
// Exports
module.exports = exports;
